import { createBrowserRouter, Navigate } from 'react-router'
import { LoginPage } from '@/features/auth/LoginPage'
import { LoginCallbackPage } from '@/features/auth/LoginCallbackPage'
import { DashboardPage } from '@/features/dashboard/DashboardPage'
import { ProtectedRoute } from '@/shared/components/ProtectedRoute'
import { PublicRoute } from '@/shared/components/PublicRoute'
import { ROUTES } from '@/shared/routes'

export const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [
      { path: ROUTES.LOGIN, element: <LoginPage /> },
      { path: ROUTES.LOGIN_CALLBACK, element: <LoginCallbackPage /> },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [{ path: ROUTES.HOME, element: <DashboardPage /> }],
  },
  { path: '*', element: <Navigate to={ROUTES.HOME} replace /> },
])
